<template>
    <section class="mb-4">
        <div class="field mt-1"
             v-if="showIntegrations">
            <p class="label">การบูรณาการกับพันธกิจด้าน{{ integration.title }}</p>
            <table class="table is-fullwidth is-countable mb-1">
                <thead>
                <tr>
                    <th>{{ title }}</th>
                    <th>วัตถุประสงค์ของการบูรณาการ</th>
                    <th>ตัวบ่งชี้ในการวัดความสำเร็จของการบูรณาการ</th>
                    <th>เป้าหมาย</th>
                    <th>ลักษณะการบูรณาการ</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(detail, index) in this.project.integration_details"
                          v-if="isIntegrationType(detail)"
                >
                    <tr>
                        <td colspan="5">
                            <div class="flex">
                                <div class="mr-1 is-counter"></div>
                                <div class="flex-grow">
                                    <input type="hidden"
                                           :name="'integrationDetails[' + index + '][id]'"
                                           v-model="detail.id"
                                    />
                                    <input type="hidden"
                                           :name="'integrationDetails[' + index + '][parameter_id]'"
                                           v-model="detail.parameter_id"
                                    />
                                    <input class="input"
                                           :name="'integrationDetails[' + index + '][title]'"
                                           v-model="detail.title"
                                           rows="4"
                                           v-autosize
                                           title="การบูรณาการ"
                                           :placeholder="integration.description"
                                    />
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <textarea class="textarea"
                                      :name="'integrationDetails[' + index + '][objective]'"
                                      v-model="detail.objective"
                                      rows="4"
                                      placeholder="วัตถุประสงค์"
                                      v-autosize
                            ></textarea>
                        </td>
                        <td>
                            <textarea class="textarea"
                                      :name="'integrationDetails[' + index + '][kpi]'"
                                      v-model="detail.kpi"
                                      rows="4"
                                      placeholder="ตัวบ่งชี้ในการวัดความสำเร็จของโครงการ"
                                      v-autosize
                            ></textarea>
                        </td>
                        <td>
                            <textarea class="textarea"
                                      :name="'integrationDetails[' + index + '][target]'"
                                      v-model="detail.target"
                                      rows="4"
                                      placeholder="เป้าหมาย"
                                      v-autosize
                            ></textarea>
                        </td>
                        <td>
                               <textarea class="textarea"
                                         :name="'integrationDetails[' + index + '][description]'"
                                         v-model="detail.description"
                                         placeholder="ลักษณะการบูรณาการ"
                                         rows="4"
                                         v-autosize
                               ></textarea>
                        </td>
                        <td>
                            <span class="delete" @click.prevent="deleteIntegration(index)"></span>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
            <button type="button" class="button is-300"
                    @click.prevent="addIntegration"
            >
                <span class="icon">
                    <i class="fa fa-plus"></i>
                </span>
                เพิ่มการบูรณาการ&nbsp;<strong>{{ integration.title }}</strong>
            </button>
        </div>
    </section>
</template>
<script type="text/babel">
    export default {
        props: {
            integration: {type: Object, required: true},
            project: {type: Object, required: true},
            TypeIntegrationDetail: {type: String, required: true}
        },
        computed: {
            title() {
                return this.integration.title === 'การเรียนการสอน' ? 'รายวิชา' : 'งานวิจัย';
            },
            showIntegrations() {
                return this.integration !== undefined && this.integration.active;
            },
            integrationDetails() {
                return _.filter(
                    this.project.integration_details,
                    (integrationDetail) => integrationDetail.parameter_id === this.integration.parameter_id
                );
            }
        },
        watch: {
            showIntegrations() {
                if (this.showIntegrations && this.integrationDetails.length === 0) {
                    this.addIntegration();
                }
            }
        },
        methods: {
            isIntegrationType(detail) {
                return detail.parameter_id == this.integration.parameter_id;
            },
            addIntegration() {
                this.project.integration_details.push({
                    id: null,
                    title: null,
                    parameter_id: this.integration.parameter_id,
                    type: this.TypeIntegrationDetail,
                    objective: null,
                    kpi: null,
                    target: null,
                });
            },
            deleteIntegration(index) {
                this.project.integration_details.splice(index, 1);
            }
        }
    }
</script>